import { Dropdown, DropdownItem, DropdownMenu, DropdownTrigger } from '@heroui/react';
import { ChevronUp, Globe } from 'lucide-react';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { useLanguageState } from '@/state';

import { i18n } from '../../../../utils/i18n';
import { SUPPORTED_LOCALES, type SupportedLocale } from '../../../../utils/locale';
import { FooterLanguageButton } from './AuthLayout.styled';

/* Nazwy języków, każda w swoim języku: przed zalogowaniem nie wiadomo, który wybierze użytkownik. */
const LANGUAGE_LABELS: Record<SupportedLocale, string> = {
  pl: 'Polski',
  en: 'English',
  de: 'Deutsch',
};

/* Zmiana języka w stopce ekranów auth (rozwija się do góry). */
export const AuthLanguageSwitch: FC = () => {
  const { t } = useTranslation();
  const { language, setLanguage } = useLanguageState();
  const currentLanguage = ((i18n.language || language || 'pl').slice(0, 2)) as SupportedLocale;

  const handleLanguageChange = (key: string) => {
    i18n.changeLanguage(key);
    setLanguage(key);
    localStorage.setItem('preAuthLanguage', key);
  };

  return (
    <Dropdown
      placement="top-start"
      classNames={{ content: 'min-w-[140px] p-1 rounded-8 border border-border-default shadow-dropdown' }}
    >
      <DropdownTrigger>
        <FooterLanguageButton type="button" aria-label={t('userProfile.selectLanguage')}>
          <Globe aria-hidden="true" />
          <span>{LANGUAGE_LABELS[currentLanguage] ?? LANGUAGE_LABELS.pl}</span>
          <ChevronUp aria-hidden="true" />
        </FooterLanguageButton>
      </DropdownTrigger>
      <DropdownMenu
        aria-label={t('userProfile.selectLanguage')}
        onAction={(key) => handleLanguageChange(String(key))}
        selectedKeys={new Set([currentLanguage])}
        selectionMode="single"
      >
        {SUPPORTED_LOCALES.map((code) => (
          <DropdownItem key={code} className="rounded-4 text-sm">
            {LANGUAGE_LABELS[code]}
          </DropdownItem>
        ))}
      </DropdownMenu>
    </Dropdown>
  );
};
